// extracted by mini-css-extract-plugin
export default {"categoryContainer":"GeneralCategories_categoryContainer__Imhuq","title":"GeneralCategories_title__mTqGb"};